import React, { Fragment } from "react";
import DividerAtm from "../../../atoms/DividerAtm";
import AlignContentOrg from "../../AlignContentOrg";
import BreakpointVisibilityOrg from "../../BreakpointVisibilityOrg";
import FlexContainerOrg from "../../FlexContainerOrg";
import FlexItemOrg from "../../FlexItemOrg";
import PushOrg from "../../PushOrg";
import { StyledInfoBox, StyledParamsBox, StyledParamValue, StyledPriceBox, StyledResultBox, StyledResultBoxContent } from "./MarketplaceCalculatorResultBox.styled";
function MarketplaceCalculatorResultBox(_ref) {
  var title = _ref.title,
    params = _ref.params,
    priceBox = _ref.priceBox,
    additionalInfo = _ref.additionalInfo,
    button = _ref.button;
  return /*#__PURE__*/React.createElement(StyledResultBox, {
    spacingSpace: 2,
    shadow: "small",
    color: "backgroundLight",
    borderRadiusSize: "mlarge"
  }, /*#__PURE__*/React.createElement(StyledResultBoxContent, null, /*#__PURE__*/React.createElement(StyledInfoBox, {
    bottomSpace: 4,
    topSpace: 2,
    rightSpace: 2,
    leftSpace: 2,
    hasNoReset: true
  }, title, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(StyledParamsBox, {
    columns: {
      small: 1,
      medium: 2,
      large: 2
    },
    gutterSpace: {
      x: 3,
      y: 1
    }
  }, params.map(function (param) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: param.key
    }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
      alignItems: "center",
      gapSpace: 1
    }, param.icon, /*#__PURE__*/React.createElement(FlexItemOrg, {
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0
    }, param.title)), /*#__PURE__*/React.createElement(StyledParamValue, null, param.value));
  })))), /*#__PURE__*/React.createElement(StyledPriceBox, null, priceBox.title, /*#__PURE__*/React.createElement(StyledParamsBox, {
    gutterSpace: {
      x: 3,
      y: 1.5
    },
    columns: {
      small: 1,
      medium: 2,
      large: 2
    }
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    alignItems: "center",
    gapSpace: 1
  }, priceBox.externalPriceItem.icon, priceBox.externalPriceItem.title), /*#__PURE__*/React.createElement(StyledParamValue, null, priceBox.externalPriceItem.value), /*#__PURE__*/React.createElement(FlexContainerOrg, {
    alignItems: "center",
    gapSpace: 1
  }, priceBox.internalPriceItem.icon, priceBox.internalPriceItem.title), /*#__PURE__*/React.createElement(StyledParamValue, null, priceBox.internalPriceItem.value)), /*#__PURE__*/React.createElement(DividerAtm, {
    marginSpace: 2,
    emphasis: "extraLow"
  }), /*#__PURE__*/React.createElement(StyledParamsBox, {
    gutterSpace: {
      x: 3,
      y: 1.5
    },
    columns: {
      small: 1,
      medium: 2,
      large: 2
    }
  }, /*#__PURE__*/React.createElement(PushOrg, {
    leftSpace: 3,
    hasNoReset: true
  }, priceBox.summaryTitle), /*#__PURE__*/React.createElement(StyledParamValue, null, priceBox.summaryPrice)))), /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 3,
    topSpace: 1
  }, /*#__PURE__*/React.createElement(AlignContentOrg, {
    horizontalAlign: "right"
  }, additionalInfo)), button);
}
export default MarketplaceCalculatorResultBox;